/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminPccResponse,
  AuthorizationStatus,
} from '../models';
import {
    AdminPccResponseFromJSON,
    AdminPccResponseToJSON,
    AuthorizationStatusFromJSON,
    AuthorizationStatusToJSON,
} from '../models';

export interface GetAdminPccRequest {
    pcc: string;
    authorization?: string;
    onBehalfOf?: string;
}

/**
 * 
 */
export class AdminPccApi extends runtime.BaseAPI {

    /**
     * Get pcc admin to act on behalf of.
     */
    async getAdminPccRaw(requestParameters: GetAdminPccRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPccResponse>> {
        if (requestParameters.pcc === null || requestParameters.pcc === undefined) {
            throw new runtime.RequiredError('pcc','Required parameter requestParameters.pcc was null or undefined when calling getAdminPcc.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin-pcc/{pcc}`.replace(`{${"pcc"}}`, encodeURIComponent(String(requestParameters.pcc))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPccResponseFromJSON(jsonValue));
    }

    /**
     * Get pcc admin to act on behalf of.
     */
    async getAdminPcc(requestParameters: GetAdminPccRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPccResponse> {
        const response = await this.getAdminPccRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
